import { render } from "./ResetIcon.vue?vue&type=template&id=7852fef4"
import script from "./ResetIcon.vue?vue&type=script&lang=js"
export * from "./ResetIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__